import dJSON from 'dirty-json';

(() => {
  const moduleSelector = '.category-boxes';

  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove();
      const { data } = dJSON.parse(query.data);
      const grid = query.querySelector('.js-category-boxes');

      data.forEach((item) => {
        grid.insertAdjacentHTML('beforeend', /* html */ `
          <a class="category-boxes__item" href="${item.link}">
            <img class="category-boxes__icon" src="${item.icon}" alt="">
            <div class="category-boxes__text">
              <span class="category-boxes__title">${item.title}</span>
              <span class="category-boxes__shop">Shop Now</span>
            </div>
          </a>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
